import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './JobDetails.module.scss';
import { Input } from '../../../../common/Form/Input/Input';
import { TextArea } from '../../../../common/Form/TextArea/TextArea';
import EditJobDetails from './EditJobDetails/EditJobDetails';
import { EditLabel } from '../../../../common/Form/EditLabel/EditLabel';

export function JobDetails(props) {
  const { jobData, updateworkHistory, createWorkHistory, updating } = props;

  const currentWork = jobData
    .filter((job) => job.CurrentlyWorkThere)
    ?.sort((a, b) => new Date(b.StartDate) - new Date(a.StartDate))[0];

  const [editJobDetails, setEditJobDetails] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={`mt-3 ${styles.JobDetails}`}>
      <EditLabel purpose={t('dashboard.profile.details.job')} onClick={() => setEditJobDetails(true)} icon />
      {editJobDetails && (
        <EditJobDetails
          jobData={currentWork}
          updateworkHistory={updateworkHistory}
          state={editJobDetails}
          changeState={setEditJobDetails}
          createWorkHistory={createWorkHistory}
          updating={updating}
        />
      )}
      <form className=" row gap-3">
        <Input
          value={currentWork?.Title}
          readOnly
          placeholder="Your Role"
          id="jobTitle"
          label="Current Job Title"
          type="text"
        />
        <Input
          value={currentWork?.CompanyName}
          readOnly
          placeholder="Your Role"
          id="jobTitle"
          label="Current Job Title"
          type="text"
        />
        <Input
          value={currentWork?.CompanyName}
          readOnly
          placeholder={t('common.forms.company')}
          id="company"
          label={t('common.forms.currentcompany')}
          type="text"
        />
        <TextArea
          value={currentWork?.Description}
          readOnly
          placeholder={t('common.forms.yourbio')}
          id="biography"
          label={t('common.forms.biography')}
          type="text"
          rows={2}
          column={1}
        />
      </form>
    </div>
  );
}
